module.exports = __webpack_public_path__ + "img/Grid view Icon - charcoal.4e4f57ab.svg";